/* unplugin-vue-components disabled */import { render } from "./OpticalPathQuestionView.vue?vue&type=template&id=5b25a02b&scoped=true"
import script from "./OpticalPathQuestionView.vue?vue&type=script&lang=js"
export * from "./OpticalPathQuestionView.vue?vue&type=script&lang=js"

import "./OpticalPathQuestionView.vue?vue&type=style&index=0&id=5b25a02b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b25a02b"]])

export default __exports__